var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useBrand } from "@/contexts/cdpConfig";
import { fetchPrefillData } from "@/utils/contacting";
import { useCallback, useEffect, useState } from "react";
import { useVisibilityEvent } from "./useVisibilityEvent";
import { useAuthentication } from "@aviv-unified-frontend/runtime/authentication";
export const usePrefill = ({ crsBaseUrl, onLoad }) => {
    const [isPrefilled, setIsPrefilled] = useState(false);
    const brand = useBrand();
    const prefillUrl = `${crsBaseUrl}/prefill-form?brand=${brand}`;
    const { unsafe_accessToken } = useAuthentication();
    const prefill = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d;
        try {
            setIsPrefilled(true);
            if (unsafe_accessToken) {
                const userData = (yield fetchPrefillData(prefillUrl, unsafe_accessToken));
                if (userData) {
                    // Map enums to strings as Gemini Dropdown component does not accept numbers as id, only strings
                    // @ts-ignore
                    const householdType = (_a = userData === null || userData === void 0 ? void 0 : userData.houseHoldType) === null || _a === void 0 ? void 0 : _a.toString();
                    const workStatus = (_b = userData === null || userData === void 0 ? void 0 : userData.workStatus) === null || _b === void 0 ? void 0 : _b.toString();
                    // @ts-ignore
                    const netMonthlyIncome = (_c = userData === null || userData === void 0 ? void 0 : userData.netIncomeBeforeTaxRange) === null || _c === void 0 ? void 0 : _c.toString();
                    const preferredMoveInDate = (_d = userData === null || userData === void 0 ? void 0 : userData.preferredMoveInDate) === null || _d === void 0 ? void 0 : _d.toString();
                    userData.householdType = householdType;
                    userData.workStatus = workStatus;
                    userData.netMonthlyIncome = netMonthlyIncome;
                    userData.preferredMoveInDate = preferredMoveInDate;
                }
                onLoad(userData);
            }
        }
        catch (error) {
            console.log(error);
            onLoad();
        }
    }), [onLoad, unsafe_accessToken, prefillUrl]);
    useVisibilityEvent({ cb: prefill, type: "visible" });
    useEffect(() => {
        if (unsafe_accessToken && !isPrefilled) {
            prefill();
        }
    }, [unsafe_accessToken, onLoad, prefill, isPrefilled]);
};
